<template>
    <div class="confirmContainer dashboard">
        <div class="dashboard__rightpanel">
            <EmptyDashboard
                :selectedPortfolio="selectedPortfolio"
                :accountInfo="accountInfo"
                @updatedInvestmentAmount="updatedInvestmentAmount"
            />
            <ConfirmPortfolio
                v-if="!editPortfolio"
                :selectedPortfolio="currentPortfolio"
                :escrowBalance="getEscrow"
                :isFirstTime="true"
                :hideChoosePlan="hideChoosePlan"
                :hidePlan="hidePlan"
                :congratulationsText="congratulationsText"
                :accountInfo="accountInfo"
                @success="reloadPage"
                @editAmount="editInvestmentAmount"
                @chooseAnotherPlan="chooseAnotherPlan"
                @insufficientFunds="insufficientFunds"
            />
        </div>
        <v-snackbar
            v-model="isInsufficientFunds"
            app
            timeout="-1"
        >
            Your Escrow Balance has insufficient funds!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isInsufficientFunds = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import EmptyDashboard from '@/components/dashboard/emptyDashboard'
import ConfirmPortfolio from '../common/confirmPortfolio.vue'

export default {
    name: 'ConfirmPortfolioDashboard',
    props: {
        selectedPortfolio: Object,
        accountInfo: Object
    },
    components: {
        ConfirmPortfolio,
        EmptyDashboard
    },
    data () {
        return {
            showAlternateProduct: '',
            isInsufficientFunds: false,
            editPortfolio: false,
            isEditPortfolio: false,
            currentPortfolio: null,
            hideChoosePlan: false,
            hidePlan: false,
            congratulationsText: false
        }
    },
    mounted () {
        this.showAlternateProduct = (this.selectedPortfolio.planType === 'income') ? 'growth' : 'income'
        this.currentPortfolio = this.selectedPortfolio
    },
    computed: {
        getEscrow () {
            return this.accountInfo.escrowBalance
        }
    },
    methods: {
        editInvestmentAmount () {
        },
        reloadPage () {
            window.location.reload()
        },
        insufficientFunds () {
            this.isInsufficientFunds = true
        },
        chooseAnotherPlan () {
            this.editPortfolio = true
        },
        goBack () {
            this.editPortfolio = false
        },
        portfolioHandler (data) {
            this.currentPortfolio = data
            this.editPortfolio = false
        },
        updatedInvestmentAmount (amount) {
            console.log('amt', amount)
            this.currentPortfolio.expectedInvestmentAmount = amount * 100
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./dashboard.scss";
.actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.buttonContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.confirmContainer {
    display: flex;
    flex-direction: column;
}
</style>
